<template>
  <div id="page-wrapper">
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">
          <i class="fa fa-circle-o-notch fa-fw"></i> Solicitações de Rotinas
        </h1>
        <h3>Será a pagina onde será feita a associação de uma empresa crendeciada e a execução de rotinas</h3>
      </div>
      <!-- /.col-lg-12 -->
    </div>
  </div>
  <!-- /#page-wrapper -->
</template>

<script>
export default {
  name: "RoutineSolicitation",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/RoutineSolicitation.vue